import {ApolloClient, gql, NormalizedCacheObject, useQuery} from '@apollo/client';
import {Query} from '../types/generated/graphql';

export const QUERY_GET_WEEKLY_BUCKETS = gql`
  query GetWeeklyBuckets($profileId: ID!) {
    getWeeklyBuckets(profileId: $profileId) {
      watched
      greatFit
      borderline
      flagged
      windowDays
    }
  }
`;

export function useGetWeeklyBuckets(
  client: ApolloClient<NormalizedCacheObject>,
  profileId: string,
) {
  type T = Pick<Query, 'getWeeklyBuckets'>;
  return useQuery<T>(QUERY_GET_WEEKLY_BUCKETS, {
    client,
    variables: {profileId},
    fetchPolicy: 'cache-and-network',
  });
}
